import * as Yup from 'yup';

export default function WfhRequestSchema() {
  return Yup.object({
    startDate: Yup.date().nullable().required('Start date is required'),
    endDate: Yup.date()
      .nullable()
      .required('End date is required')
      .when('isHalfDay', {
        is: true,
        then: (schema) =>
          schema
            .min(Yup.ref('startDate'), 'End date must equal start date for half-day WFH')
            .max(Yup.ref('startDate'), 'End date must equal start date for half-day WFH'),
        otherwise: (schema) =>
          schema.min(Yup.ref('startDate'), 'End date must be greater than or equal to start date'),
      }),
    isHalfDay: Yup.boolean(),
    halfDayType: Yup.string().when('isHalfDay', {
      is: true,
      then: (schema) =>
        schema
          .oneOf(['first_half', 'second_half'], 'Please select half day type')
          .required('Half day type is required when selecting half day WFH'),
      otherwise: (schema) => schema.notRequired(),
    }),
    reason: Yup.string()
      .max(500, 'Reason must be less than 500 characters')
      .required('Reason is required'),
    reviewers: Yup.array()
      .of(Yup.number().integer().positive())
      .min(1, 'At least one reviewer must be selected')
      .required('At least one reviewer is required'),
  });
}
